// src/store/permission.store.ts
import { create } from 'zustand'
import { persist, createJSONStorage, PersistOptions } from 'zustand/middleware'

interface usePermissionStoreState {
  // your new form fields
  fullName: string
  setFullName: (fullName: string) => void

  phone: string
  setPhone: (phone: string) => void

  areas: string[]
  setAreas: (areas: string[]) => void

  selectedPermission: number | null
  setSelectedPermissionStore: (selected: number | null) => void

  // existing fields
  choosedPermission: IPermission | null
  setChoosedPermission: (choosed: IPermission | null) => void

  text: string
  setText: (text: string) => void

  openEdit: boolean
  setOpenEdit: (openEdit: boolean) => void

  color: string
  setColor: (color: string) => void
}

export const usePermissionStore = create(
  persist<usePermissionStoreState>(
    (set, get) => ({
      // initialize your form fields
      fullName: '',
      setFullName: (fullName) => set({ fullName }),

      phone: '',
      setPhone: (phone) => set({ phone }),

      areas: [],
      setAreas: (areas) => set({ areas }),

      selectedPermission: null,
      setSelectedPermissionStore: (selected) => set({ selectedPermission: selected }),

      // the rest of your existing state
      choosedPermission: null,
      setChoosedPermission: (choosed) => set({ choosedPermission: choosed }),

      text: '',
      setText: (text) => set({ text }),

      openEdit: false,
      setOpenEdit: (openEdit) => set({ openEdit }),

      color: '#fff',
      setColor: (color) => set({ color }),
    }),
    {
      name: 'permission-storage',
      storage: createJSONStorage(() => localStorage),
    } as PersistOptions<usePermissionStoreState, usePermissionStoreState>
  )
)
